<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
        <div class="page__section">
            <nav class="breadcrumb breadcrumb_type5" aria-label="Breadcrumb">
                <ol class="breadcrumb__list r-list">
                    <li class="breadcrumb__group">
                        <a [routerLink]="['/analysis']" class="breadcrumb__point r-link" title="Analiz">Analiz</a>
                        <span class="breadcrumb__divider" aria-hidden="true"> › </span>
                    </li>
                    <li class="breadcrumb__group">
                        <span class="breadcrumb__point" aria-current="page">{{detail?.title}}</span>
                    </li>
                </ol>
            </nav>
        </div>
       <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
                <div class="row ">
                    <h1 style="display:inline-block;" class="info-detail-title">{{detail?.title}}</h1>
                    <div style="display:inline-block;" *ngIf="isBrowser" class="mb-3 mt-3">
                        <share-buttons [theme]="'circles-light'"
                            [include]="['facebook','twitter','linkedin','pinterest','reddit','tumblr','mix','viber','vk','telegram','messenger','whatsapp','xing','line','sms','email','print','copy']"
                            [exclude]="['mix','viber','xing','sms','email','print']" [show]="3" [autoSetMeta]="false">
                        </share-buttons>
                    </div>
                    <ng-template ngFor let-info [ngForOf]="detail?.infos" let-i="index" [ngForTrackBy]="trackByFnInfo">
                        <div [innerHTML]="detail?.infos[i] | keepHtml" style="text-align: left"></div>
                        <!-- <app-ads-header [adsId]="'1408095'"  [adsName]="'info-detail-1'+detail?.url" [adsStyle]="'#M856326ScriptRootC1408095{min-height: 300px;}'"></app-ads-header> -->
                    </ng-template>
                    <div style="display:inline-block; text-align:center;" *ngIf="isBrowser">
                        <share-buttons [theme]="'circles-light'"
                            [include]="['facebook','twitter','linkedin','pinterest','reddit','tumblr','mix','viber','vk','telegram','messenger','whatsapp','xing','line','sms','email','print','copy']"
                            [exclude]="['mix','viber','xing','sms','email','print']" [show]="3" [autoSetMeta]="false">
                        </share-buttons>
                    </div>
                   <div style="text-align: center;">
                        <app-comment [commentCount]="commentCount"  [title]="title" [rootId]="rootId"></app-comment>
                    </div>
                </div>
                <app-company [code]="detail?.code"></app-company>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis> 
                <app-summary-info></app-summary-info>           
                <app-draft-dividend [toYear]="year"></app-draft-dividend>  
                <app-draft-month [toYear]="year"></app-draft-month>                  
            </div>                        
        </div>
    </div>
</section>